import { useRouter } from 'next/router'
import { checkIsServiceNonTopUp, PaymentPayee, useCyberStore } from '@entities/tsp'
import { getResultPath } from '@entities/payment'
import { useToast } from '@shared/lib/toast'
import { generatePath } from '@shared/lib'
import { CYBER_PAY_URL_RESULT, ewalletReqHeaders } from '@shared/config'
import { TransactionResponse } from '@root/api/ump-ewallet'
import { getConfirmationContent } from '../lib/getConfirmationContent'
import { usePaymentDo } from './usePaymentDo'
import { TRANSACTION_STATE } from '../config/transactionStates'

interface usePayByCardArgs {
  showVouchersForm: boolean
  payee: PaymentPayee
}

export const usePayByCard = ({ showVouchersForm, payee }: usePayByCardArgs) => {
  const router = useRouter()
  const { toast } = useToast()

  const { pcekMdOrder } = useCyberStore()

  const { paymentDo, isLoading: isPaymentDoLoading } = usePaymentDo()

  const url = router.query.id as string

  const payByCard = () => {
    const onError = (error) => toast({ variant: 'error', description: error?.message as string })

    const isNonTopUpService = checkIsServiceNonTopUp(showVouchersForm, payee)

    const redirectToResult = (mdOrder: string) => {
      const generatedPath = `${generatePath(CYBER_PAY_URL_RESULT, { mdOrder })}?url=${url}&voucher=${isNonTopUpService}`

      router.push(generatedPath)
    }

    const handleCallError = (errorMessage?: string) => {
      toast({ variant: 'error', title: 'Ошибка платежа', description: errorMessage || '' })
    }

    const onSuccess = (data: TransactionResponse) => {
      if (data.state === TRANSACTION_STATE.DEPOSITED || data.state === TRANSACTION_STATE.IN_PROGRESS) {
        redirectToResult(data?.mdOrder as string)
      } else if (data.state === TRANSACTION_STATE.WAITING_CONFIRMATION) {
        getConfirmationContent({
          paymentData: data,
          getResultPath: () =>
            `${window.location.origin}/${getResultPath(
              data?.mdOrder as string,
              `?url=${url}&voucher=${isNonTopUpService}`
            )}`,
          handleError: handleCallError,
        })
      }
    }

    paymentDo({
      mdOrder: pcekMdOrder,
      onError,
      onSuccess,
      options: {
        headers: {
          ...ewalletReqHeaders,
          fhprequestid: window?.gibRequestId,
          fhpsessionid: window?.gibSessionId,
        },
      },
    })
  }

  return { payByCard, isPaymentByCardLoading: isPaymentDoLoading }
}
